export default function PropsProvider() {
  return function (context, funcDetails, payload) {
    context.props = payload || {};
    return context;
  };
}